import type { StaticImageData } from 'next/image';
import HealthGoalsImg from '../../public/assets/homepage-redesign/weekly-collections/health-goals.jpg';
import FamilyNightImg from '../../public/assets/homepage-redesign/weekly-collections/family-night.jpg';
import DateNightImg from '../../public/assets/homepage-redesign/weekly-collections/date-night.jpg';
import FakeawayImg from '../../public/assets/homepage-redesign/weekly-collections/fakeaway.jpg';

export type Collection = {
  readonly label: string;
  readonly image: StaticImageData;
  readonly imageAlt: string;
};

export const COLLECTIONS: readonly Collection[] = [
  {
    label: 'Health goals',
    image: HealthGoalsImg,
    imageAlt: 'A colourful grain and leaf salad being served from a bowl',
  },
  {
    label: 'Family night',
    image: FamilyNightImg,
    imageAlt: 'A parent and child topping a homemade pizza together',
  },
  {
    label: 'Date night',
    image: DateNightImg,
    imageAlt: 'A couple sharing noodle bowls together on a sofa',
  },
  {
    label: 'Fakeaway',
    image: FakeawayImg,
    imageAlt: 'Loaded chips and crispy chicken shared at a table',
  },
];
